import { set_dimensions } from "../../../services/global.services";

var email_card_styles = function(app_dimensions: any) {
  return {
    body: {
      display: "flex",
      width: set_dimensions().desktop ? "" : "",
      maxWidth: set_dimensions().desktop
        ? "500px"
        : "clamp(300px, 40vw, 640px)",
      padding: set_dimensions().desktop
        ? "48px 56px 80px 56px"
        : "20px 20px 32px 20px",
      flexDirection: "column" as const,
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center" as const,
      gap: "40px",
      border: "1px solid var(--Gray---75, #F3F4F5)",
      background: "var(--White, #FFF)",
      boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.1)",
      borderRadius: "1rem",
    },
    card_head: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "flex-start",
      gap: "24px",
      alignSelf: "stretch",
    },
    headline: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "flex-start",
      gap: "8px",
      alignSelf: "stretch",
    },
    card_title: {
      alignSelf: "stretch",
      color: "var(--Black---1000, #191924)",
      fontFamily: "Montserrat",
      fontSize: set_dimensions().desktop ? "32px" : "24px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: set_dimensions().desktop ? "40px" : "32px",
      padding: 0,
      margin: 0,
    },
    card_subtitle: {
      alignSelf: "stretch",
      color: "var(--Gray---800, #4F5467)",
      fontFamily: "Montserrat",
      fontSize: set_dimensions().desktop ? "16px" : "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: set_dimensions().desktop ? "24px" : "20px",
      padding: 0,
      margin: 0,
    },
    input_container: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "flex-start",
      gap: "6px",
      alignSelf: "stretch",
    },
    input_title_container: {
      display: "flex",
      alignItems: "flex-end",
      gap: "2px",
    },
    input_title: {
      color: "var(--Gray---800, #4F5467)",
      fontFamily: "Montserrat",
      fontSize: "13px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "16px",
    },
    input_child_container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "4px",
      alignSelf: "stretch",
    },
    button_disabled: {
      display: "flex",
      height: "48px",
      padding: "12px 12px 12px 16px",
      justifyContent: "center",
      alignItems: "center",
      gap: "4px",
      alignSelf: "stretch",
      borderRadius: "4px",
      background: "var(--Gray---200, #D3D8DE)",
      color: "var(--White, #FFF)",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "20px",
      border: "none",
      marginTop: "40px",
    },
    button: {
      display: "flex",
      height: "48px",
      padding: "12px 12px 12px 16px",
      justifyContent: "center",
      alignItems: "center",
      gap: "4px",
      alignSelf: "stretch",
      borderRadius: "4px",
      background: "var(--Black---1000, #191924)",
      color: "var(--White, #FFF)",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "20px",
      border: "none",
      marginTop: "40px",
    },
    logo: {
      width: "92.8px",
      height: "16px",
      flexShrink: 0,
      // paddingLeft: set_dimensions().desktop ? "55px" : "",
    },
    body_2: {
      display: "flex",
      width: set_dimensions().desktop ? "" : "",
      maxWidth: set_dimensions().desktop
        ? "500px"
        : "clamp(300px, 40vw, 640px)",
      padding: set_dimensions().desktop ? "3rem" : "20px 20px 32px 20px",
      flexDirection: "column" as const,
      alignItems: "flex-start",
      alignSelf: set_dimensions().desktop ? "" : "stretch",
      gap: "28px",
      // borderRadius: "24px",
      border: "1px solid var(--Gray---75, #F3F4F5)",
      background: "var(--White, #FFF)",
      // height: set_dimensions().desktop ? "" : "330px",
      textAlign: "start" as const,
      height: "100%",
      justifyContent: "space-between",
      boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.1)",
      borderRadius: "1rem",
    },
    back_btn_contain: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "0px",
      textAlign: "left" as const,
    },
    back_btn: {
      display: "flex" as const,
      width: "107px" as const,
      height: "16px" as const,
      justifyContent: "center" as const,
      alignItems: "center" as const,
    },
    back_btn_text: {
      display: "flex" as const,
      width: "107px" as const,
      height: "16px" as const,
      flexDirection: "column" as const,
      justifyContent: "center" as const,
      flexShrink: 0 as const,
      color: "var(--Black---1000, #191924)" as const,
      fontFamily: "Montserrat" as const,
      fontSize: "16px" as const,
      fontStyle: "normal" as const,
      fontWeight: 600 as const,
      lineHeight: "20px" as const,
      textDecorationLine: "underline" as const,
      textDecorationStyle: "solid" as const,
      textDecorationSkipInk: "auto" as const,
      textDecorationThickness: "auto" as const,
      textUnderlineOffset: "auto" as const,
      textUnderlinePosition: "from-font" as const,
      paddingLeft: "1vw",
    },
    icon_contain: {
      display: "flex",
      padding: set_dimensions().desktop ? "16px" : "12px",
      justifyContent: "center",
      alignItems: "center",
      gap: set_dimensions().desktop ? "10px" : "7.5px",
      borderRadius: set_dimensions().desktop ? "100px" : "120px",
      background: "var(--Green---10, #F7FAF0)",
      flexShrink: set_dimensions().desktop ? "" : 0,
      height: set_dimensions().desktop ? "" : "72px",
    },
    icon: {
      width: set_dimensions().desktop ? "64px" : "64px",
      height: set_dimensions().desktop ? "62px" : "62px",
    },
    confirm_head: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "flex-start",
      alignSelf: "stretch",
      margin: 0,
      padding: 0,
    },
    confirm_headline: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "flex-start",
      alignSelf: "stretch",
      margin: 0,
      padding: 0,
    },
    confirm_title: {
      color: "var(--Black---1000, #191924)",
      fontFamily: "Montserrat" as const,
      fontSize: set_dimensions().desktop ? "32px" : "24px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: set_dimensions().desktop ? "40px" : "30px",
      margin: 0,
      padding: 0,
    },
    confirm_subtitle: {
      alignSelf: "stretch",
      color: "var(--Gray---800, #4F5467)",
      fontFamily: "Montserrat" as const,
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: set_dimensions().desktop ? "24px" : "24px",
      margin: 0,
      padding: 0,
      marginTop: "15px",
    },
    confirm_email: {
      color: "var(--Black---1000, #191924)",
      fontFamily: "Montserrat" as const,
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: set_dimensions().desktop ? "16px" : "48px",
      margin: set_dimensions().desktop ? "0" : 0,
      padding: set_dimensions().desktop ? "0" : 0,
      marginTop: "15px",
    },
    resend_button: {
      color: "var(--Black---1000, #191924)",
      fontFamily: "Montserrat" as const,
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: set_dimensions().desktop ? "16px" : "48px",
      margin: set_dimensions().desktop ? 0 : 0,
      padding: set_dimensions().desktop ? 0 : 0,
      background: "none",
      backgroundColor: "none",
      border: "none",
      textTransform: "none" as const,
      marginTop: "40px",
    },
  };
};

export default email_card_styles;